import { ReactNode, forwardRef } from 'react';
import { Button, ButtonProps } from './ui/button';
import { cn } from '../lib/utils';
import { transCls } from '../const/ui';
import { BsTooltip } from './tooltip';

export interface IconBtnProps extends ButtonProps {
  icon: ReactNode;
  rounded?: boolean;
  tooltip?: string;
}

export const IconBtn = forwardRef<HTMLButtonElement, IconBtnProps>(
  ({ icon, className, tooltip, size, rounded, ...rest }, ref) => {
    const btn = (
      <Button
        ref={ref}
        variant="ghost"
        size="icon"
        className={cn(
          'p-2.5',
          {
            'rounded-full w-[26px] h-[26px] aspect-square !text-[#121111]': rounded,
            'rounded-[4px]': !rounded,
          },
          'cursor-pointer',
          'hover:!bg-[#EFF0F6]',
          className,
          transCls
        )}
        {...rest}
      >
        {icon}
      </Button>
    );

    if (tooltip) {
      return <BsTooltip content={tooltip}>{btn}</BsTooltip>;
    }

    return btn;
  }
);
